import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PaginateTotal from '../common/PaginateTotal';
import ReactPaginate from 'react-paginate';
import moment from 'moment';

class GeneralNewsTable extends Component {
    
    render() {
        const { t } = this.props;
        const { items, pageNo, pageSize, total } = this.props;

        if (items === null) {
            return (
                <p>News not found</p>
            );
        } else {
            return (
                <div className="table-container main-style circulars-table">
                    <table>
                        <tbody>
                            <tr>
                                <th>
                                    <a>{t('general.table.headers.issueDate')}</a>
                                </th>
                                <th>
                                    <a>{t('general.table.headers.title')}</a>
                                </th>
                            </tr>
                        </tbody>
                        <tbody>
                        {items.map((news) => {
                            const docUrl = `doc?refNo=${news.newsRefNo}`;
                            return (
                            <tr key={news.newsRefNo}>
                                <td>
                                    {t('common:date.formatter',{date: moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}
                                </td>
                                <td>
                                    <Link to={docUrl}>{news.title}</Link>
                                </td>
                            </tr>
                            );
                        })}
                        </tbody>
                    </table>
                    <div className="pagination-toolbar">
                        <PaginateTotal pageNo={pageNo} pageSize={pageSize} total={total} />
                        <div className="pagination-toolbar pagebar">
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                breakLabel={'. . .'}                                        
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={7}
                                initialPage={pageNo}
                                disableInitialCallback={true}
                                pageCount={Math.ceil(total/pageSize)}
                                onPageChange={this.props.handlePageChange}
                                containerClassName={'pagination'}
                                previousClassName={'previous'}
                                breakClassName={'break'}
                                pageClassName={'page'}
                                activeClassName={'active'}
                                nextClassName={'next'}/>
                        </div>                        
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(withTranslation()(GeneralNewsTable));